module.exports = __webpack_public_path__ + "fonts/Roboto-500-greek11.9ac81fe.woff2";